import * as echarts from "echarts";

type EChartsOption = echarts.EChartsOption;

export const activeCandelas = (data: number[][]):void => {
    
    // eslint-disable-next-line
    const chartDom = document.getElementById("container")!;
    const myChart = echarts.init(chartDom);
    
    const option: EChartsOption = {
        xAxis: {
            show: false,
            data: new Array(data.length).fill("")
        },
        yAxis: {
            show: false,
        },
        grid: {
            top: 0,
            left: "-5%",
            right: "-5%",
            bottom: 0
        },
        series: [
            {
                type: "candlestick",
                data: data,
                name: "1",
                animationDuration: 1200,
                animationEasing: "bounceOut",
                itemStyle: {
                    color0: "transparent",
                    color: "transparent",
                    borderWidth: 0.6
                }
            },
            {
                name: "line1",
                type: "line",
                data: data.map((opt) => opt[3]).reverse().sort((a,b) => a-b),
                smooth: false,
                showSymbol: false,
                lineStyle: {
                    width: 3,
                    color: "#4a5968"
                }
            },
        ]
    };
    
    option && myChart.setOption(option);
};
